export const FounderMenu = [
  {
    title: "Home",
    to: "/",
  },
  {
    title: "About Us",
    to: "/about-us",
  },
  {
    title: "How It Works",
    to: "/how-it-works",
  },

  // {
  //   title: "Projects",
  //   classChange: "sub-menu-down",
  //   content: [
  //     {
  //       title: "Project",
  //       to: "/project",
  //     },
  //     {
  //       title: "Project Categories",
  //       to: "/project-categories",
  //     },
  //     {
  //       title: "Project Sidebar",
  //       to: "/project-sidebar",
  //     },
  //     {
  //       title: "Project Story",
  //       to: "/project-story",
  //     },
  //   ],
  // },
  {
    title: "Projects",
    to: "/project",
  },

  {
    title: "FAQ",
    to: "/faq",
  },

  {
    title: "Contact Us",
    to: "./contact-us",
  },
];
